import styled from 'styled-components';

export const BadgeGroup = styled.ul`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const BadgeItem = styled.li`
  margin: 0;
  padding: 0;
  opacity: 1;
`;
